module.exports = __webpack_public_path__ + "static/media/code2.85bb73b8.jpg";